<template>
  <div class="bridge-signing-view container fluid">
    <v-card>
      <PaybackView />
    </v-card>
  </div>
</template>

<script>
import { PaybackView } from '@/components/payoutsAndTaxes';

export default {
  name: 'PaybacksView',
  components: {
    PaybackView,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.bridge-signing-view {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/payoutsAndTaxes/paybacks/view/PaybacksView.vue